<template>
  <div class="product-images-wrapper">
    <div class="close-modal p-2 float-right">
      <svg @click="closeProdMZoomModal" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
        <g>
          <path fill="none" d="M0 0h24v24H0z" transform="translate(-1 1) translate(1 -1)"/>
          <path fill="rgba(0,0,0,0.5)" stroke="rgba(255,255,255,0.6)" d="M12 2a10 10 0 1 0 10 10A9.991 9.991 0 0 0 12 2z" transform="translate(-1 1) translate(1 -1)"/>
          <path fill="#fff" d="M16.237 8L13 11.238 9.762 8 8 9.762 11.238 13 8 16.237 9.762 18 13 14.763 16.237 18 18 16.237 14.763 13 18 9.762z" transform="translate(-1 1) translate(0 -2)"/>
        </g>
       </svg>
    </div>
    <div class="zoom-parent">
      <div class="video-show" v-if="videoUrl && isVideoActive === 1 && (currImage === videoIndex - 1 || videoIndex === 0)"
        @touchstart="handleTouchStart"
         @touchmove="handleTouchMove" 
         @touchend="handleTouchEnd">
        <VideoPlayer
          :src="videoUrl" 
          :poster="getActiveImage"
          :playVideo="playVideo"
        />
      </div>
      <div v-else class="productZoomer" @touchstart="handleTouchStart"
         @touchmove="handleTouchMove" 
         @touchend="handleTouchEnd">
        <img :src="getActiveImage" /> 
      </div>
    </div>
    <div class="imgList-wrap ml-2 mr-2 d-flex flex-row">
      <carousel ref="my-carousel"
        :paginationEnabled="false" navigationNextLabel=" " navigationPrevLabel=" "
        :autoplay="false" :paginationPadding="7" class="bannerview"
        :perPageCustom="[[480, 2], [768, 4], [1200, 5], [1920, 6]]"
        :perPage="4"
        :navigateTo="navShown ? getcurrPage : 0"
      >
        <slide v-for="(prm, index) in getImageArray" :key="index">
          <div class="card-container pointer m-1'">
            <img class="img-card"
              :data-src="prm"
              :class="index !== currImage ? 'p-3' : 'p-2'"
              @click="switchImage(index)"
            />
            <div class="overlay" v-if="videoUrl && isVideoActive === 1 && (index === videoIndex-1 || videoIndex ===0)" @click="switchImage(index)">
              <img src="https://tss-static-images.gumlet.io/media/play.png"
                style="height:20px;"
              />
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<script>
  import PinchZoom from 'pinch-zoom-js'
  import {Carousel, Slide} from 'vue-carousel'
  import VideoPlayer from './VideoPlayer.vue'
  import device from 'vue-device-detector-js'
  import Vue from 'vue'
  Vue.use(device)
  export default {
    props: ['imgArray', 'activeImg', 'videoUrl', 'isVideoActive', 'videoIndex'],
    data () {
      return {
        prodImgPath: process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG,
        currImage: 0,
        navShown: false,
        playVideo: true,
        pzCapture: null,
        touchStartX: 0,
        touchEndX: 0,
        isSwiping: false,
        isZoomed: false,
        touchStartEvent: null
      }
    },
    components: {
      Carousel,
      Slide,
      VideoPlayer
    },
    methods: {
      closeProdMZoomModal () {
        this.$emit('closeProdZoomModal', false)
      },
      handleTouchStart (event) {
        this.touchStartEvent = event
        const touch = event.touches[0] || event.changedTouches[0]
        this.touchStartX = touch.screenX
        this.touchStartTime = new Date().getTime()
        this.isSwiping = false
      },
      handleTouchMove (event) {
        const touch = event.touches[0] || event.changedTouches[0]
        this.touchEndX = touch.screenX
        this.isSwiping = true
      },
      handleTouchEnd (e) {
        if (this.pzCapture.zoomFactor > 1) {
          this.isZoomed = true
        } else {
          this.isZoomed = false
        }
        if (this.isiOS && !this.isSwiping) {
          this.iphoneSingleTapHandler(this.touchStartEvent)
          return
        }
        if (this.isSwiping && !this.isZoomed) {
          if (this.touchEndX < this.touchStartX && this.currImage < this.getImageArray.length - 1) {
            this.switchImage(this.currImage + 1)
          } else if (this.touchEndX > this.touchStartX && this.currImage > 0) {
            this.switchImage(this.currImage - 1)
          }
        }
        this.isSwiping = false
      },
      switchImage (index) {
        this.currImage = index
        this.pzCapture.zoomOutAnimation()
        if (this.videoUrl && this.isVideoActive === 1 && (index === this.videoIndex - 1 || this.videoIndex === 0)) {
          this.pzCapture.disable()
        } else {
          this.pzCapture.enable()
        }
      },
      initiateZommer () {
        let el = document.querySelector('div.productZoomer')
        let pz = new PinchZoom(el, {
          tapZoomFactor: 2,
          minZoom: 1,
          draggableUnzoomed: false,
          setOffsetsOnce: true
        })
        this.pzCapture = pz
        pz.enable()
      },
      iphoneSingleTapHandler (e) {
        if (this.$device.machine.os_name.toLowerCase() === 'ios') {
          this.pzCapture.handleDoubleTap(e)
        }
      },
      isiOS () {
        return this.$device.machine.os_name.toLowerCase() === 'ios'
      }
    },
    computed: {
      getActiveImage () {
        return this.prodImgPath + this.imgArray[this.currImage]
      },
      getImageArray () {
        return this.imgArray && this.imgArray.map((img) => {
          return this.prodImgPath + img
        })
      },
      getcurrPage () {
        return parseInt(this.currImage / 4)
      }
    },
    mounted () {
      this.currImage = this.activeImg
      this.initiateZommer()
      setTimeout(() => {
        this.navShown = true
      }, 600)
    },
    beforeDestroy () {
      document.body.classList.remove('noscroll')
    }
  }
</script>
<style scoped>
.product-images-wrapper{
  background-color: #ffffff;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 9999;
  top: 0;
  transition: 0.3s;
  overflow: hidden;
}
.close-modal {
  height: 50px;
}
.imgList-wrap {
  overflow-x:auto;
  overflow-y: hidden;
  bottom: 0;
  margin-top: 7%;
  scrollbar-width: none;
}
.pinch-zoom-container {
  position: fixed !important;
  top: 50px !important;
  height: 40vh !important;
}
.zoom-parent {
  width: 90%;
  margin-left: 5%;
  margin-top: 14%;
  height: 72.1%;
}
.overlay {
  position: absolute;
  bottom: 42%;
  margin-left: 10%;
}
@media screen and (min-height: 1024px) {
 .zoom-parent {
    height: 65%;
    margin-top: 8%;
  }
  .imgList-wrap {
    margin-top: 3%;
  }
}
@media screen and (max-height: 750px) {
  .zoom-parent {
    height: 65%;
    margin-top: 16%;
  }
  .imgList-wrap {
    margin-top: 12%;
  }
}
.img-card {
  object-fit: contain;
  width: 25vh;
}
.imgList-wrap::-webkit-scrollbar { width: 0 !important }
@media screen and (max-width: 479px) {
  .product-images-wrapper .imgList-wrap .VueCarousel-slide {
    visibility: visible;
    flex-basis: 25%;
    width: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// productZoomModal.vue?2a379f82